<template>
  <div class="pl-4 py-2 pr-6 grow flex justify-between items-center gap-8">
    <div class="w-2/3 h-9 bg-gray-200 rounded-lg animate-pulse" />
    <div class="w-36 h-9 bg-gray-200 rounded-lg animate-pulse" />
  </div>
</template>

<script setup></script>
